<template>
    <div
        class="empty-results relative flex flex-col items-center justify-center pt-12"
        v-if="searchCompleted && searchResults.length === 0"
    >
        <div
            class="w-16 h-16 bg-slate-200 rounded-full justify-center items-center gap-2.5 inline-flex mb-5"
        >
            <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    id="vector"
                    d="M26.6575 26.6653L21.3909 21.3987M23.9909 14.6654C23.9909 19.82 19.8122 23.9987 14.6576 23.9987C9.50289 23.9987 5.32422 19.82 5.32422 14.6654C5.32422 9.51071 9.50289 5.33203 14.6576 5.33203C19.8122 5.33203 23.9909 9.51071 23.9909 14.6654Z"
                    stroke="#475569"
                    stroke-width="2.66667"
                    stroke-linecap="round"
                />
            </svg>
        </div>
        <h5
            class="text-slate-800 text-lg font-medium font-['Inter'] leading-7 mb-3"
        >
            No matching hotels found
        </h5>

        <p
            class="text-slate-500 text-sm font-normal font-['Inter'] leading-tight mb-7"
        >
            Try changing your search parameters.
        </p>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useHotelsStore } from '@/store/hotels';
const hotelsStore = useHotelsStore();
const searchResults = computed(() => hotelsStore.searchResults.data);
const { searchCompleted } = storeToRefs(hotelsStore);
</script>
